import React from 'react';
import { Helmet } from 'react-helmet-async';
import styled from '@emotion/styled';
import { theme } from '../styles/theme';

const PageWrapper = styled.div`
  min-height: 100vh;
  background: #fff;
  padding: 120px 2rem 4rem;
`;

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

const PageTitle = styled.h1`
  font-family: 'Poppins', sans-serif;
  font-size: 2rem;
  color: #111;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 3px solid ${theme.colors.primary};
`;

const Section = styled.section`
  margin-bottom: 2rem;
`;

const SectionTitle = styled.h2`
  font-family: 'Poppins', sans-serif;
  font-size: 1.1rem;
  font-weight: 600;
  color: #111;
  margin-bottom: 0.75rem;
`;

const Text = styled.p`
  font-family: 'Montserrat', sans-serif;
  font-size: 0.95rem;
  color: #333;
  line-height: 1.7;
  margin-bottom: 0.4rem;
`;

const Link = styled.a`
  color: ${theme.colors.primary};
  text-decoration: none;
  &:hover { text-decoration: underline; }
`;

const Impressum = () => {
  return (
    <>
      <Helmet>
        <title>Impressum – Optik Geissler</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <PageWrapper>
        <Container>
          <PageTitle>Impressum</PageTitle>

          <Section>
            <SectionTitle>Angaben gemäß § 5 ECG</SectionTitle>
            <Text><strong>Unternehmensbezeichnung:</strong> Optik Geissler</Text>
            <Text><strong>Inhaber:</strong> Christian Geissler</Text>
            <Text><strong>Unternehmensgegenstand:</strong> Augenoptik und optometrische Dienstleistungen</Text>
          </Section>

          <Section>
            <SectionTitle>Standorte</SectionTitle>
            <Text><strong>Bad Radkersburg</strong></Text>
            <Text>Hauptplatz 5, 8490 Bad Radkersburg</Text>
            <Text>Tel.: <Link href="tel:+4334762036">+43 3476 200 36</Link></Text>
            <Text>E-Mail: <Link href="mailto:radkersburg@optik-geissler.at">radkersburg@optik-geissler.at</Link></Text>

            <br />

            <Text><strong>Mureck</strong></Text>
            <Text>Quellengasse 1, 8480 Mureck</Text>
            <Text>Tel.: <Link href="tel:+4334723164">+43 3472 301 64</Link></Text>
            <Text>E-Mail: <Link href="mailto:mureck@optik-geissler.at">mureck@optik-geissler.at</Link></Text>
          </Section>

          <Section>
            <SectionTitle>Behörde</SectionTitle>
            <Text>Zuständige Gewerbebehörde: Bezirkshauptmannschaft Südoststeiermark</Text>
            <Text>Mitglied der Wirtschaftskammer Steiermark, Fachgruppe Augenoptik</Text>
          </Section>

          <Section>
            <SectionTitle>Berufsrechtliche Regelungen</SectionTitle>
            <Text>
              Gewerbeordnung 1994 (GewO) –{' '}
              <Link href="https://www.ris.bka.gv.at" target="_blank" rel="noopener noreferrer">
                www.ris.bka.gv.at
              </Link>
            </Text>
          </Section>

          <Section>
            <SectionTitle>UID-Nummer</SectionTitle>
            <Text>ATU67390478</Text>
          </Section>

          <Section>
            <SectionTitle>Haftungsausschluss</SectionTitle>
            <Text>
              Die Inhalte dieser Website wurden mit größtmöglicher Sorgfalt erstellt. Für die Richtigkeit,
              Vollständigkeit und Aktualität der Inhalte übernehmen wir jedoch keine Gewähr.
            </Text>
          </Section>

          <Section>
            <SectionTitle>Urheberrecht</SectionTitle>
            <Text>
              Die auf dieser Website veröffentlichten Inhalte und Werke unterliegen dem österreichischen
              Urheberrecht. Jede Vervielfältigung, Bearbeitung oder Verbreitung außerhalb der Grenzen des
              Urheberrechts bedarf der schriftlichen Zustimmung des jeweiligen Urhebers.
            </Text>
          </Section>

          <Section>
            <SectionTitle>Online-Streitbeilegung</SectionTitle>
            <Text>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
              <Link href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">
                https://ec.europa.eu/consumers/odr
              </Link>
            </Text>
            <Text>
              Unsere E-Mail-Adresse finden Sie oben im Impressum. Wir sind weder bereit noch verpflichtet,
              an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </Text>
          </Section>
        </Container>
      </PageWrapper>
    </>
  );
};

export default Impressum;
